export default function PlayBtn({ handleVideoBtn, playing }) {
  return (
    <>
      <span className="ob-play" onClick={handleVideoBtn}>
        <img
          src={
            !playing
              ? process.env.PUBLIC_URL + `/button-play.svg`
              : process.env.PUBLIC_URL + `/button-pause.svg`
          }
          alt={!playing ? `Play Button` : `Pause Button`}
        />
      </span>
    </>
  );
}
